import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import CompromiseListWait from './../CompromiseListWait/CompromiseListWait';
import CompormiseTransact from './../CompormiseTransact/CompormiseTransact';
import CompromiseListOrder from './../CompromiseListOrder/CompromiseListOrder';

import Son1 from './testrouter';


class App extends Component {

    render() {
        return (
            <Switch>
                <Route exact path="/Content/Business/CompromiseListWait" component={CompromiseListWait} />
                <Route exact path="/Content/Business/CompromiseListWait/CompormiseTransact" component={CompormiseTransact} />
                <Route exact path="/Content/Business/CompromiseListOrder/proces" component={CompromiseListOrder} />
               
            </Switch>
        );
    }
}

export default App


// WEBPACK FOOTER //
// ./src/components/Content/Business/Compromise/CompromiseRouter/CompromiseRouter.js